import { render, staticRenderFns } from "./jicaiDetailB.vue?vue&type=template&id=cc8d4680&"
import script from "./jicaiDetailB.vue?vue&type=script&lang=js&"
export * from "./jicaiDetailB.vue?vue&type=script&lang=js&"
import style0 from "./jicaiDetailB.vue?vue&type=style&index=0&id=cc8d4680&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports